import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import banner1 from "../../assets/images/banner1.png";
import './Home.css';

export default function Hero({ banners = [] }) {

  const slidesToRender = banners.length > 0 ? banners : [
    { banner_image: banner1, banner_title: "Default Banner 1" },
    { banner_image: banner1, banner_title: "Default Banner 2" },
    { banner_image: banner1, banner_title: "Default Banner 3" }
  ];

  return (
     <div className="slider-wrapper hero_slider">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
        navigation
        pagination={{ clickable: true }}
      >
        {slidesToRender.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="slide slide1">
             <img src={slide.banner_image} alt={slide.banner_title || "Cares At Home"} className='img-fluid'/>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}


